import onEnter from './onEnter';
import onEscape from './onEscape';

const onKeyEvents = {
  onEnter,
  onEscape,
};

export default onKeyEvents;
